export default __webpack_public_path__ + "static/media/medicenter-slider-image-3.f4f10feb.jpg";